export const myTeamProfile100KDownloadDetailsReducer = (state = {}, action) => {
    if (action.type === 'POST_UPG_MY_TEAM_PROFILE_100K_DOWNLOAD') {
      return {
        ...state,
        MyTeamProfile100KDownloadDetailsRd: action.payload,
      };
    } else {
      return state;
    }
  };